(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["df-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.dfMarqueeReady) return;
  window.dfMarqueeReady = true;

  var MAX_RUNS = 40;

  /* Two copies only fill the strip when one copy is already wider than the
     viewport. Below that the loop exposes bare band on the right, because at
     the end of a cycle the runs have shifted one run-width left and there is
     nothing behind them. Clone until the runs cover the strip with two to
     spare: one for the width being scrolled through, one for the reset. */
  function fill(mq) {
    var track = mq.querySelector('.df-mq__track');
    if (!track) return;

    var first = track.querySelector('.df-mq__run');
    if (!first) return;

    var runWidth = first.getBoundingClientRect().width;
    var stripWidth = mq.getBoundingClientRect().width;
    if (runWidth < 1 || stripWidth < 1) return;

    var needed = Math.min(MAX_RUNS, Math.ceil(stripWidth / runWidth) + 2);
    if (track.children.length >= needed) return;

    while (track.children.length < needed) {
      track.appendChild(first.cloneNode(true));
    }

    /* A clone starts its animation the moment it is inserted, so the copies
       would drift out of phase with the originals. Drop the animation on every
       run, force a reflow, then restore it so they all begin on the same tick. */
    var runs = track.querySelectorAll('.df-mq__run');
    var i;
    for (i = 0; i < runs.length; i++) runs[i].style.animationName = 'none';
    void track.offsetWidth;
    for (i = 0; i < runs.length; i++) runs[i].style.animationName = '';
  }

  function scan(root) {
    (root || document).querySelectorAll('.df-mq').forEach(fill);
  }

  scan();
  document.addEventListener('DOMContentLoaded', function () {
    scan();
  });
  /* Widths are measured from laid-out text, so a webfont swapping in after
     first paint changes them. Re-measure once the fonts have settled. */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      scan();
    });
  }
  window.addEventListener('resize', function () {
    scan();
  });
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
